import {
  Checkbox,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useMemo } from "react";
import { useObjetivos } from "../../../../context/SuperAdmin/OASContexts/ObjetivosContext";
import { StyledTableCell } from "../../../../ui-components/StyledTables";
import { ObjetivosRow } from "./ObjetivosRow";

const ObjetivosTable = () => {
  const { objetivos, setSelectedObjetivos, selectedObjetivos, searchText } =
    useObjetivos();

  const selectAll = () => {
    setSelectedObjetivos(filteredObjetivos.map((obj) => obj.id_objetivo));
  };

  // Manejar selección/deselección de un objetivo
  const handleSelect = (id: string) => {
    setSelectedObjetivos((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  // Filtro de objetivos por búsqueda
  const filteredObjetivos = useMemo(() => {
    const normalizedSearch = searchText.toLowerCase().trim();
    return objetivos.filter((u) =>
      u.nombre.toLowerCase().includes(normalizedSearch)
    );
  }, [objetivos, searchText]);

  return (
    <TableContainer
      sx={{
        width: "100%",
        margin: "auto",
        borderRadius: 2,
        overflow: "hidden",
      }}
    >
      <Table sx={{ minWidth: 500, width: "100%" }} aria-label="simple table">
        <TableHead sx={{ height: 20 }}>
          <TableRow>
            <StyledTableCell sx={{ maxWidth: "100px", width: 50 }}>
              <Checkbox
                color="primary"
                checked={selectedObjetivos.length > 0} // Check general
                onChange={(e) => {
                  if (e.target.checked) {
                    selectAll();
                  } else {
                    setSelectedObjetivos([]);
                  }
                }}
                sx={{
                  color: "white", // Color del checkbox cuando no está seleccionado
                  "&.Mui-checked": {
                    color: "white", // Color del icono cuando está seleccionado
                  },
                  "& .MuiSvgIcon-root": {
                    border: "2px solid white", // Borde blanco alrededor del checkbox
                    borderRadius: "4px", // Bordes redondeados
                  },
                }}
              />
            </StyledTableCell>
            <StyledTableCell sx={{ mb: 2, textAlign: "center" }}>
              N°
            </StyledTableCell>
            <StyledTableCell sx={{ mb: 2, textAlign: "center" }}>
              Nombre
            </StyledTableCell>
            <StyledTableCell sx={{ mb: 2, textAlign: "center" }}>
              Fecha de creación
            </StyledTableCell>
            <StyledTableCell sx={{ mb: 2, textAlign: "center" }}>
              Acciones
            </StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {filteredObjetivos.length > 0 ? (
            filteredObjetivos.map((item, index) => (
              <ObjetivosRow
                objetivo={item}
                i={index + 1}
                key={item.id_objetivo}
                handleSelect={handleSelect}
                isSelected={selectedObjetivos.includes(item.id_objetivo)}
              />
            ))
          ) : (
            <TableRow>
              <StyledTableCell
                colSpan={9}
                sx={{
                  paddingTop: "12px",
                  paddingBottom: "12px",
                  textAlign: "center",
                }}
              >
                No hay campos aún
              </StyledTableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ObjetivosTable;
